import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

const BasicDropdown = ({
  label,
  data = [],
  initValue,
  onValueChange = () => {},
  addNoSelectionOption = true,
  disabled,
  formControlProps = {},
  selectProps = {},
  menuItemProps = {},
  size = "medium",
}) => {
  const [selectedId, setSelectedId] = useState("");

  // Keep only the `id` as selected value
  useEffect(() => {
    if (![null, undefined].includes(initValue) || ![null, undefined].includes(initValue?.id)) {
      setSelectedId(initValue?.id ?? initValue);
    } else {
      setSelectedId("");
    }
  }, [initValue]);

  const handleChange = (event) => {
    const id = event.target.value;
    setSelectedId(id);
    const selectedItem = data.find((item) => item.id === id) || null;
    onValueChange(event, selectedItem);
  };

  return (
    <FormControl fullWidth disabled={disabled} {...formControlProps}>
      {label && (
        <InputLabel id="select-label" shrink>
          {label}
        </InputLabel>
      )}
      <Select
        size={size}
        labelId="select-label"
        value={selectedId}
        label={label}
        onChange={handleChange}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return <span className="text-gray-400">Select an Option</span>;
          }
          const selectedItem = data.find((item) => item.id === selected);
          return selectedItem?.label || "";
        }}
        {...selectProps}
      >
        {addNoSelectionOption && (
          <MenuItem value="" {...menuItemProps}>
            <span>No Selection</span>
          </MenuItem>
        )}
        {data.map((menuItem, idx) => (
          <MenuItem
            key={`${menuItem.id}-${idx}`}
            value={menuItem.id}
            disabled={!!menuItem?.disabled}
            {...menuItemProps}
          >
            {menuItem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BasicDropdown;
